import { ApolloClient, from, HttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import config from '@config';
import { QueryClient } from '@tanstack/react-query';
// import secureStore from '@utils/secureStore';
import tokenManager from '@utils/secureStore/tokenManager';

// Client provider for api(s)
export const queryClient = new QueryClient();

const authLink = setContext(async (_, { headers }) => {
  const token = tokenManager.getAccessToken();
  // await secureStore.getItemAsync('accessToken');
  return {
    headers: {
      ...headers,
      authorization: `Bearer ${token}`,
    },
  };
});

const errorLink = onError(() =>
  // { graphQLErrors, networkError, operation, forward }
  {
    // console.log('graphQLErrors', graphQLErrors);
  },
);

const httpLink = new HttpLink({
  uri: config.GRAPHQL_URL,
});

// GraphQL Provider
export const gqClient = new ApolloClient({
  link: from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache(),
});
